import { Link, useNavigate } from 'react-router-dom'
import ContentFrom from '../../components/ContentForm'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateContent } from '../../hooks/contents'

export default function ContentCreate() {
  const createContent = useCreateContent()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/contents">Contenuti</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <ContentFrom
          save={async (content) => {
            const savedContent = await createContent.mutateAsync(content)
            navigate(`/contents/${savedContent.id}`)
          }}
        />
      </div>
    </Page>
  )
}
